import React from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

import groceryshop from "../images/Grocerylogo.png";
import amazonpay from "../images/amazonpay.svg";
import american from "../images/american-express.svg";
import mastercard from "../images/mastercard.svg";
import paypal from "../images/paypal.svg";
import visa from "../images/visa.svg";

const Footer = () => {
  const year = new Date().getFullYear();

  const categories = [
    "Dairy, Bread & Eggs",
   
    "Cold Drinks & Juices",
    "Breakfast & Instant Food",
    "Bakery & Biscuits",
   
  ];

  return (
    <footer className="footer mt-5">
      <div className="container">
        <div className="row">

          {/* BRAND */}
          <div className="col-md-3 mb-4">
            <Link to="/">
              <img src={groceryshop} alt="FreshCart" style={{ width: 200 }} />
            </Link>
            <p className="mt-3">
              Fresh groceries delivered to your doorstep with speed and trust.
            </p>

            <h6 className="mt-3">Payment Partners</h6>
            <div className="d-flex gap-2 flex-wrap">
              {[amazonpay, american, mastercard, paypal, visa].map((img, i) => (
                <img key={i} src={img} alt="payment" style={{ height: 26 }} />
              ))}
            </div>
          </div>

 

          {/* POLICIES */}
          <div className="col-md-3 mb-4">
            <h5>For Consumers</h5>
            <ul className="list-unstyled">
              <li><Link to="/shipping-policy">Shipping Policy</Link></li>
              <li><Link to="/return-replacement-policy">Return & Replacement</Link></li>
              
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* COMPANY */}
          <div className="col-md-3 mb-4">
            <h5>Company</h5>
            <ul className="list-unstyled">
              <li><Link to="/AboutUs">About Us</Link></li>
              <li><Link to="/contact">Contact / Help Center</Link></li>
            </ul>

            <div className="d-flex gap-3 mt-3">
              <a href="https://facebook.com" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f" /></a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer"><i className="fab fa-twitter" /></a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer"><i className="fab fa-instagram" /></a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in" /></a>
            </div>
          </div>

        </div>

        {/* BOTTOM BAR */}
        <hr />
        <div className="text-center pb-3">
          © {year} All Rights Reserved by{" "}
          <a
            href="https://vkiranastore.netlify.app/portfallio"
            target="_blank"
            rel="noreferrer"
          >
            @vishalkumar
          </a>
          <span className="mx-2">|</span>
          <Link to="/terms-of-service">Terms</Link>
          <span className="mx-2">|</span>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
